import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class RestrictedWordService {

  constructor(
    private http:HttpClient  , private snotifyService: ToastrService,
  ) {
   }




   getAllRestrictWords(prams:any){
   return this.http.post('/RestrictedWord/GetAllRestrictedWords',prams)
   }

   upsertRestrictWord(pram:any){
    return this.http.post('/RestrictedWord/UpsertRestrictedWord',pram)
   }

   deleteRestrictWord(id:any){
    return this.http.post(`/RestrictedWord/DeleteRestrictedWord/${id}`,{})
   }


   openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }


}
